module.exports = __webpack_public_path__ + "static/media/008_g5_1Configure playlist empty.08cffc61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/008_g5_1Configure playlist empty.png
// module id = 435
// module chunks = 0